import React, { Component } from 'react';
import { Icon } from 'antd';

class EditTableCell extends Component {
    state = {
        isEnter: false,
    }

    changeEnter = () => {
        this.setState(prevState => ({
            isEnter: !prevState.isEnter,
        }));
    }

    render() {
        const { isEnter } = this.state;
        const { text, record, activeKey } = this.props;
        const { canEdit, employeeCode, userCompellation } = record;
        if (!text && canEdit) {
            return (
                <div
                    style={{
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        right: 0,
                        bottom: 0,
                        background: isEnter ? 'rgba(0,0,0,0.2)' : '',
                    }}
                    onMouseEnter={this.changeEnter}
                    onMouseLeave={this.changeEnter}
                >
                    {
                        isEnter &&
                        <Icon
                            type="edit"
                            style={{
                                position: 'absolute',
                                top: '50%',
                                left: '50%',
                                transform: 'translate(-50%, -50%)',
                                color: '#fff',
                                cursor: 'pointer',
                            }}
                            onClick={() => this.props.onChange(activeKey, {employeeCode, userCompellation})}
                        />
                    }
                </div>
            );
        } else {
            return <span>{text}</span>;
        }
    }
}

export default EditTableCell;


// WEBPACK FOOTER //
// ./src/components/user/userInfo/EditTableCell.js